module.exports = "/images/ELIANA_ZOTESSO_RAMOS.jpg?bf18601907ce61bceb1873d169f92e33";